<template>
  <div class="gwd-table nested h-full">
    <div
      class="gwd-table-header"
      :class="isAdmin || isManager ? 'supplier-cost' : 'supplier-cost-worker'"
    >
      <span>Hankija</span>
      <span class="mobile:col-span-2">Kirjeldus</span>
      <span>Kogus</span>
      <span>Kulu</span>
      <span v-if="isAdmin || isManager">Tulu</span>
      <span v-else>Kokku</span>
      <span v-if="isAdmin || isManager">Käibemaks</span>
      <span class="flex" v-if="isAdmin || isManager">Kulu/Tulu summa</span>
      <span v-if="isAdmin || isManager">Seotud arve</span>
      <span />
    </div>
    <div class="gwd-table-row-wrapper">
      <supplier-cost-planning
        v-for="planningCost in supplierCostPlannings"
        :key="planningCost.id"
        :planning-cost="planningCost"
        @deletePlanningCost="(planning) => (planningToDelete = planning)"
        @updatePlanningCost="updatePlanningCost"
        @convertToCost="convertToCost"
      />
      <div
        class="gwd-table-header nopad"
        v-if="supplierCostPlannings.length > 0"
      />
      <compact-cost
        :class="isAdmin || isManager ? 'supplier-cost' : 'supplier-cost-worker'"
        v-for="supplierCost in taskSupplierCosts"
        :key="supplierCost.id"
        :cost="supplierCost"
        :tax-types="taxTypes"
        :extra-slot="(isAdmin || isManager) && !!supplierCost.supplier"
        :block-delete="supplierCost.invoice"
        @costsUpdated="loadTaskSupplierCosts"
      >
        <span :class="{ 'text-danger': !supplierCost.supplier }">
          {{
            supplierCost.supplier
              ? supplierCost.supplier.name
              : "HANKIJA PUUDUB"
          }}
        </span>
        <template
          #extra
          v-if="(isAdmin || isManager) && !!supplierCost.supplier"
        >
          <div class="flex items-center">
            <div
              v-if="supplierCost.invoice"
              class="flex cursor-pointer"
              @click.left.exact="navigateToInvoice(supplierCost.invoice.id)"
              @click.middle.exact="navigateToInvoice(supplierCost.invoice.id)"
              @click.ctrl.exact="navigateToInvoice(supplierCost.invoice.id)"
            >
              Arve: {{ supplierCost.invoice.invoice_nr }} /
              {{
                supplierCost.invoice.queue_number
                  ? supplierCost.invoice.queue_number
                  : "-"
              }}
            </div>

            <div v-else>
              <button
                class="btn-primary"
                @click="
                  () => {
                    selectInvoiceForCost = supplierCost;
                    $store.commit(`modals/taskModal/setAddInvoiceToCostModal`, {
                      show: true,
                      supplier: selectInvoiceForCost.supplier,
                    });
                  }
                "
              >
                <span class="label">Liida arvega</span>
              </button>
            </div>
          </div>
        </template>
      </compact-cost>
      <span
        v-if="
          taskSupplierCosts.length === 0 && supplierCostPlannings.length === 0
        "
        class="p-2"
      >
        Hankijakulusid pole.
      </span>
    </div>

    <div class="gwd-table-bottom-bar">
      <button
        class="btn-primary mr-3"
        v-if="isAdmin || isManager"
        @click="
          $store.commit('modals/taskModal/openAddSupplierCostModal', {
            isPlanning: true,
          })
        "
      >
        Planeeri hankija kulu
      </button>
      <button
        v-if="
          isAdmin ||
          isManager ||
          (['R4', 'R5'].includes(userPermissions) &&
            moment(taskTime.end).diff(moment(), 'hours') >= -12 &&
            !taskConfirmed)
        "
        class="btn-primary"
        @click="
          $store.commit('modals/taskModal/openAddSupplierCostModal', {
            isPlanning: false,
          })
        "
      >
        <span class="label">{{
          isAdmin || isManager ? "Lisa kulu" : "Lisa prügi/vms kulu"
        }}</span>
      </button>
    </div>
    <delete-confirm-modal
      v-if="planningToDelete"
      @confirmDelete="deletePlannedCost"
      @closeModal="planningToDelete = null"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "../../../assets/mixins/GewodoMixins";
import CompactCost from "@/components/tasks/costs/CompactCost.vue";
import { round2 } from "@/assets/utils/commonMath";
import set from "lodash/set";
import DeleteConfirmModal from "@/components/reusable/DeleteConfirmModal.vue";
import SupplierCostPlanning from "@/components/tasks/costs/SupplierCostPlanning.vue";
import moment from "moment";

export default {
  name: "TaskSupplierAssignments",
  components: { SupplierCostPlanning, DeleteConfirmModal, CompactCost },
  props: {
    taskId: {
      type: String,
      default: null,
    },
    taskConfirmed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskSupplierCostsLoaded: false,
      taskSupplierCosts: [],
      addSupplierCost: false,
      supplierCostPlannings: [],
      addSupplierCostPlanning: false,
      planningToDelete: null,
      moment: moment,
      selectInvoiceForCost: null,
    };
  },
  methods: {
    round2,
    loadTaskSupplierCosts() {
      this.apiRequest(
        `template/${this.companyId}/plannings/supplier/?task=${this.taskId}`,
        "get",
        true
      ).then((res) => {
        this.supplierCostPlannings = res.data;
        for (let supplierCostPlanning of this.supplierCostPlannings) {
          if (supplierCostPlanning.vat) {
            set(
              supplierCostPlanning,
              "vatType",
              this.taxTypes.find((x) => x.id === supplierCostPlanning.vat) ??
                null
            );
          }
        }
      });
      this.apiRequest(
        `costs/${this.companyId}/supplier/costs/?task=${this.taskId}`,
        "get",
        true
      ).then((res) => {
        this.taskSupplierCosts = res.data;
        for (let supplierCost of this.taskSupplierCosts) {
          if (supplierCost.vat) {
            set(
              supplierCost,
              "vatType",
              this.taxTypes.find((x) => x.id === supplierCost.vat) ?? null
            );
          }
        }
        this.taskSupplierCostsLoaded = true;
      });
    },
    convertToCost(planningCost) {
      this.$store.commit("modals/taskModal/openAddSupplierCostModal", {
        isPlanning: false,
        planningCost: planningCost,
      });
    },
    navigateToInvoice(id) {
      const route = this.$router.resolve({
        path: `/invoices/incoming/${id}/`,
      });
      window.open(route.href, "_blank");
      // this.$router.push(`/invoices/incoming/${id}?task_id=${this.taskId}`);
      // this.$store.dispatch("modals/taskModal/close", this.taskId);
    },
    updatePlanningCost(e) {
      if (e.vatType) e.vat = e.vatType.id;
      this.apiRequest(
        `template/${this.companyId}/supplier/task/${this.taskId}/${e.id}/edit/`,
        "patch",
        true,
        e
      ).then((res) => {
        if (res.status === 200) this.loadTaskSupplierCosts();
      });
    },
    deletePlannedCost() {
      if (!this.planningToDelete) return;
      this.apiRequest(
        `template/${this.companyId}/supplier/task/${this.taskId}/${this.planningToDelete.id}/delete/`,
        "delete",
        true
      ).then((res) => {
        if (res.status === 200) this.loadTaskSupplierCosts();
      });
    },
    addInvoiceToCost(invoice) {
      if (!invoice) return;
      this.apiRequest(
        `costs/${this.companyId}/costs/supplierCost/${this.selectInvoiceForCost.id}/edit/`,
        "patch",
        true,
        { invoice: invoice.id }
      ).then((res) => {
        if (res.status === 200) {
          this.selectInvoiceForCost = null;
          this.loadTaskSupplierCosts();
          EventBus.$emit("reloadSupplierCosts");
        }
      });
    },
  },
  async mounted() {
    if (!this.taxTypes)
      await this.$store.dispatch("companyVariables/retrieveTaxTypes");
    this.loadTaskSupplierCosts();
    EventBus.$on("supplierCostAdded", this.loadTaskSupplierCosts);
    EventBus.$on("addInvoiceToCost", this.addInvoiceToCost);
  },
  beforeDestroy() {
    EventBus.$off("supplierCostAdded", this.loadTaskSupplierCosts);
    EventBus.$off("addInvoiceToCost", this.addInvoiceToCost);
  },
  computed: {
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
      isAdmin: "companyData/isAdmin",
      isManager: "companyData/isManager",
      taxTypes: "companyVariables/taxTypes",
      userPermissions: "companyData/userPermission",
      taskTime: "modals/taskModal/taskTime",
    }),
  },
};
</script>
<style lang="scss">
.supplier-cost {
  grid-template-columns: 0.4fr 0.6fr 0.2fr 0.1fr 0.1fr 0.2fr 0.2fr 0.3fr 0.15fr;
  @media screen and (max-width: 601px) {
    @apply flex-wrap m-1 border-b border-b-offwhite-dark w-full gap-y-1;
    grid-template-columns: 0.34fr 0.33fr 0.33fr;
  }
}
.supplier-cost-worker {
  grid-template-columns: 0.4fr 0.6fr 0.1fr 0.1fr 0.1fr;
  @media screen and (max-width: 601px) {
    @apply flex-wrap m-1 border-b border-b-offwhite-dark w-full gap-y-1;
    grid-template-columns: 0.34fr 0.33fr 0.33fr;
  }
}
</style>
